'use strict';

let processInclude = require('base/util');
require('core/components/spinner');

// const productGrid = document.querySelector('.product-grid-container');

$(document).ready(function () {
  processInclude(require('core/search/search'));
  processInclude(require('./search/search-result-page'));
  processInclude(require('tealium/tealiumEvents'));
  // processInclude(require('adobeTarget/loadRecommendations'));
  // processInclude(require('./product/productCarousel'));
});
